var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBloodHealth = function SvgBloodHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#537A5E",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.554 20.047c3.816 1.022 7.41-.011 8.025-2.309l.077-.286c.615-2.297-1.98-4.989-5.796-6.011s-7.41.01-8.026 2.308l-.077.286c-.615 2.297 1.98 4.989 5.797 6.012Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M14.29 15.283c.535.857-1.228 1.597-3.694.936-2.465-.66-3.75-2.062-2.73-2.657"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.71 13.158c2.22-1.472 3.34-3.68 2.518-5.104l-.11-.19c-.877-1.52-3.636-1.57-6.162-.112-.91.526-1.666 1.176-2.22 1.864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.82 8.628c.677.156.18 1.371-1.338 2.248"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.04 7.125c-.524-.979-1.522-1.951-2.836-2.651-2.456-1.31-5.087-1.173-5.875.305l-.098.185C2.537 6.264 3.5 8.17 5.413 9.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.835 7.505c.194.567-.924.758-2.26.046-1.337-.713-1.891-1.695-1.222-1.902"
  })))));
};
export default SvgBloodHealth;